var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"workflow-fields__field"},[_c('q-checkbox',{class:{ 'valid-error': _vm.invalid },attrs:{"value":_setup.workflowCheckboxFieldValue,"label":_vm.field.label},on:{"input":_setup.setField}}),(_vm.invalid)?_c('div',{staticClass:"valid-error-message"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }